import React, { useEffect } from "react";
import { privacyData } from "../../data/data";
import styles from "./privacypolicy.module.scss";
import CommonBanner from "../../components/CommonBanner/CommonBanner";
import { images } from "../../source";

const PrivacyPolicy = () => {
  const dataList = privacyData.map((item, i) => (
    <div className={styles.text_container} key={i}>
      <h3
        className={styles.heading}
        dangerouslySetInnerHTML={{ __html: item.heading }}
      ></h3>
      <p
        className={styles.description}
        dangerouslySetInnerHTML={{ __html: item.description }}
      ></p>
    </div>
  ));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <CommonBanner
        text1="Privacy Policy"
        disable
        title="PRIVACY <br />POLICY"
        image={images.termsBanner.image}
      />
      <section className={styles.privacy_sec1}>
        <div className="my_container">
          <div className={styles.text_container}>{dataList}</div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
